import ScoringType from './ScoringType.js';

// @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/enum/plate-appearance-result-statgrab.json
// @see also https://docs.google.com/document/d/1Tzpf6Z0tahdFu27C_QiIi02eAnVv4zA7S1VMS-UCbCs/edit#bookmark=id.b8cvipw5oop6
const PlateAppearanceResult = {
    NotAvailable: { key: 'NA', name: 'Not Applicable' },
    Single: { key: 'SE', name: 'Single' },
    Double: { key: 'DE', name: 'Double' },
    Triple: { key: 'TE', name: 'Triple' },
    HomeRun: { key: 'HR', name: 'Home Run' },
    Walk: { key: 'BB', name: 'Walk' },
    IntentionalWalk: { key: 'IBB', name: 'Intentional Walk' },
    HitByPitch: { key: 'HP', name: 'Hit By Pitch' },
    ReachedOnError: { key: 'E', name: 'Reached On Error' },
    SwingingStrikeout: { key: 'SSO', name: 'Strikeout Swinging' },
    CalledStrikeout: { key: 'CSO', name: 'Strikeout Looking' },
    InsideTheParkHomeRun: { key: 'IHR', name: 'Inside The Park Home Run' },
    FieldersChoice: { key: 'FC', name: 'Fielder’s Choice' },
    BatterInterference: { key: 'BI', name: 'Batter Interference' },
    CatcherInterference: { key: 'CI', name: 'Catcher Interference' },
    FieldOut: { key: 'CO', name: 'Field Out' },
    FoulOut: { key: 'FBO', name: 'Foul Out' },
    FoulTipOut: { key: 'FTO', name: 'Foul Tip Out' },
    SacrificeFly: { key: 'SF', name: 'Sacrifice Fly' },
    SacrificeBunt: { key: 'SH', name: 'Sacrifice Bunt' },
    SacrificePlay: { key: 'SAC', name: 'Sacrifice Play' },
    SacrificeOnFieldersChoice: { key: 'FCS', name: 'Sacrifice On Fielder’s Choice' },
    SacrificeOnError: { key: 'ES', name: 'Sacrifice On Error' },
    GroundRuleDouble: { key: 'GRD', name: 'Ground Rule Double' },
    InfieldFly: { key: 'IF', name: 'Infield Fly' },
    WildPitch: { key: 'WP', name: 'Wild Pitch' },
    PassedBall: { key: 'PB', name: 'Passed Ball' },
    BatterOut: { key: 'BO', name: 'Batter Out' },
    Unidentified: { key: 'UI', name: 'Unidentified' },

    listKeys() {
        return Object.values(this).map(item => item.key);
    }
};

const PlateAppearancePerScoringType = {
    [ScoringType.StatGrab.key]: PlateAppearanceResult,
    [ScoringType.extendedTagging.key]: {
        // note, PLATE_APPEARANCE_RESULT for extended tagging is a bit limited compared to default StatGrab set
        // see https://docs.google.com/spreadsheets/d/1epxNaZ5vb5523jMQ9Q4mgjbUb-M6w6wALANRcL5gAlY/edit#gid=1286954846&range=A39:A65
        // see hhttps://bitbucket.org/flightscope/dto-schema/src/master/baseball/enum/plate-appearance-result-extended-tagging.json
        NotAvailable: PlateAppearanceResult.NotAvailable,
        Single: PlateAppearanceResult.Single,
        Double: PlateAppearanceResult.Double,
        Triple: PlateAppearanceResult.Triple,
        HomeRun: PlateAppearanceResult.HomeRun,
        Walk: PlateAppearanceResult.Walk,
        IntentionalWalk: PlateAppearanceResult.IntentionalWalk,
        HitByPitch: PlateAppearanceResult.HitByPitch,
        ReachedOnError: PlateAppearanceResult.ReachedOnError,
        CalledStrikeout: PlateAppearanceResult.CalledStrikeout,
        SwingingStrikeout: PlateAppearanceResult.SwingingStrikeout,
        // InsideTheParkHomeRun removed
        FieldersChoice: PlateAppearanceResult.FieldersChoice,
        FieldOut: PlateAppearanceResult.FieldOut,
        FoulOut: PlateAppearanceResult.FoulOut,
        FoulTipOut: PlateAppearanceResult.FoulTipOut,
        // SacrificeFly removed
        // SacrificeBunt removed
        // SacrificePlay removed
        // SacrificeOnFieldersChoice removed
        // SacrificeOnError removed
        // GroundRuleDouble removed
        // InfieldFly removed
        // WildPitch removed
        // PassedBall removed
        BatterOut: PlateAppearanceResult.BatterOut,
    },
};

export default PlateAppearanceResult;
export {
    PlateAppearanceResult,
    PlateAppearancePerScoringType
};